import { GetAttestationResponseDTO } from '@/api/attestation/DTOs';
import { IAttestation } from '@/typings';
import { adaptDecimalValueToPercentage } from '../utilities';

export const adaptGetAttestationResponseToAttestation = (
  applicationAttestationResponse: GetAttestationResponseDTO,
): IAttestation => {
  return {
    requiredFieldsCount:
      applicationAttestationResponse.fieldsSummary.requiredFieldsCount,
    fieldsCount: applicationAttestationResponse.fieldsSummary.fieldsCount,
    pendingRequiredFieldsCount:
      applicationAttestationResponse.fieldsSummary.pendingRequiredFieldsCount,
    pendingFieldsCount:
      applicationAttestationResponse.fieldsSummary.pendingFieldsCount,
    restrictionViolationsCount:
      applicationAttestationResponse.fieldsSummary.restrictionViolationsCount,
    completedPercentage: adaptDecimalValueToPercentage(
      applicationAttestationResponse.fieldsSummary.completedPercentage,
    ),
    instructions: applicationAttestationResponse.instructions,
    validationMessages: applicationAttestationResponse.validationMessages,
    estimatedWorkRemainingInMinutes:
      applicationAttestationResponse.estimatedWorkRemainingInMinutes,
  };
};
